module.exports = __webpack_public_path__ + "static/img/Bradley_Hill_desktop.d2eb9d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bradley_Hill_desktop.jpg
// module id = eQc0
// module chunks = 0